var cov_1qwsjwod2o = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Button/Once.tsx",
      hash = "1fe55ebeb4d6ff5aa00584503e41f4928db0fd61",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Button/Once.tsx",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 7,
          column: 16
        }
      },
      "1": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 11,
          column: 5
        }
      },
      "2": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 50
        }
      },
      "3": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 34
        }
      },
      "4": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 36
        }
      },
      "5": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "6": {
        start: {
          line: 19,
          column: 17
        },
        end: {
          line: 19,
          column: 27
        }
      },
      "7": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 93
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        loc: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 14,
            column: 3
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 16,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        loc: {
          start: {
            line: 16,
            column: 48
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 16
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 11
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 27
          }
        }, {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 27
          }
        }],
        line: 19
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Button/Once.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Button from './Button';

var OnceButton =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(OnceButton, _PureComponent);

  var _super = _createSuper2(OnceButton);

  function OnceButton(props) {
    var _this;

    _classCallCheck(this, OnceButton);

    cov_1qwsjwod2o.f[0]++;
    cov_1qwsjwod2o.s[0]++;
    _this = _super.call(this, props);
    cov_1qwsjwod2o.s[1]++;
    _this.state = {
      loading: props.loading
    };
    cov_1qwsjwod2o.s[2]++;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OnceButton, [{
    key: "handleClick",
    value: function handleClick(e) {
      cov_1qwsjwod2o.f[1]++;

      var _ref = (cov_1qwsjwod2o.s[3]++, this.props),
          onClick = _ref.onClick;

      cov_1qwsjwod2o.s[4]++;
      this.setState({
        loading: true
      });
      cov_1qwsjwod2o.s[5]++;

      if (onClick) {
        cov_1qwsjwod2o.b[0][0]++;
        cov_1qwsjwod2o.s[6]++;
        onClick(e);
      } else {
        cov_1qwsjwod2o.b[0][1]++;
      }
    }
  }, {
    key: "render",
    value: function render() {
      cov_1qwsjwod2o.f[2]++;
      cov_1qwsjwod2o.s[7]++;
      return (
        /*#__PURE__*/
        React.createElement(Button, Object.assign({}, this.props, {
          loading: this.state.loading,
          onClick: this.handleClick,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 23,
            columnNumber: 12
          }
        }))
      );
    }
  }]);

  return OnceButton;
}(PureComponent);

export default OnceButton;